import { render, staticRenderFns } from "./DropdownNotifications.vue?vue&type=template&id=4c6afa8c&"
import script from "./DropdownNotifications.vue?vue&type=script&lang=js&"
export * from "./DropdownNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports